import { useAuth } from "@clerk/clerk-react";
import useSWR from "swr";
import { TLocation } from "../types/Locations";
import { apiDelete, apiPatch, apiPost, fetcher } from "../utils/axios";

const useLocations = () => {
  const { getToken } = useAuth();
  const { data, error, mutate } = useSWR(`/locations`, async (url) => {
    const token = await getToken();
    return fetcher(url, token);
  }, {
    revalidateOnFocus: false
  });

  const createLocation = async (data: TLocation) => {
    const token = await getToken();
    const location = await apiPost(`/locations`, data, token);
    mutate();
    return location;
  };

  const updateLocationById = async (locationId: string, data: Partial<TLocation>) => {
    const token = await getToken();
    console.log("data", data);
    await apiPatch(`/locations/${locationId.toLowerCase()}`, data, token);

    mutate()
  };

  const deleteLocation = async (locationId: string) => {
    const token = await getToken();
    await apiDelete(`/locations/${locationId.toLowerCase()}`, token);
    mutate();
  };

  return {
    locations: data as TLocation[] | [],
    isLoading: !error && !data,
    isError: error,
    createLocation,
    mutate,
    updateLocationById,
    deleteLocation,
  };
};

const useLocation = (id: string) => {
  const { getToken } = useAuth();
  const { data, error } = useSWR(`/locations/${id}`, async (url) => {
    const token = await getToken();
    return fetcher(url, token);
  });

  return {
    location: data as TLocation | undefined,
    isLoading: !error && !data,
    isError: error,
  };
};

export { useLocation, useLocations };
